/**
 * WhatsApp mesaj taslağı (sonucun altında, tam genişlik; şartname 4). Taslağı sunucu üretir (`istemci.mesaj`);
 * ekran yalnız gösterir, düzenletir ve kopyalatır. Göndermeyi satışçı yapar; ekran hiçbir şey göndermez.
 */
import { HIZLI_METIN as M } from '../metin/hizliTeklif';
import { Ikon } from './Ikon';
import type { MesajTonu } from './tipler';

export function MesajBlogu({
  etiket,
  metin,
  metinDegisti,
  guncelDegil,
  eskimis,
  kopyalaAcik,
  kopyalaNedeni,
  pdfAcik,
  ton,
  tonDegisti,
  kopyala,
  pdfIndir,
  mesgul,
}: {
  etiket: string;
  metin: string;
  metinDegisti: (m: string) => void;
  /** Fiyat süresi doldu ya da talep değişti: taslak salt okunur. */
  guncelDegil: boolean;
  /** Seçim değişti, metin eski seçimden. */
  eskimis: boolean;
  kopyalaAcik: boolean;
  kopyalaNedeni: string | null;
  pdfAcik: boolean;
  ton: MesajTonu;
  tonDegisti: (t: MesajTonu) => void;
  kopyala: () => void;
  pdfIndir: () => void;
  mesgul: boolean;
}) {
  const bos = metin === '';
  return (
    <section className="ht-kart" aria-labelledby="ht-mesaj-baslik" data-testid="ht-mesaj-blok">
      <div className="ht-kart-ust">
        <h2 id="ht-mesaj-baslik">{M.mesajBaslik}</h2>
        <div className="ht-ton" role="group" aria-label={M.mesajTonu}>
          {(['SICAK', 'RESMI', 'KISA'] as const).map((t) => (
            <button key={t} type="button" className="ht-btn ht-btn-s" aria-pressed={ton === t} onClick={() => tonDegisti(t)}>{M.tonlar[t]}</button>
          ))}
        </div>
      </div>
      {bos ? <p className="ht-ipucu">{M.mesajBosAcik}</p> : (
        <>
          {guncelDegil ? <div className="ht-bilgi-kutu ht-bilgi-tehlike" data-testid="ht-mesaj-guncel-degil"><Ikon ad="uyari" /><span>{M.mesajGuncelDegil}</span></div> : null}
          {!guncelDegil && eskimis ? <div className="ht-bilgi-kutu ht-bilgi-uyari"><Ikon ad="uyari" /><span>{M.neden.eskiMesaj}</span></div> : null}
          <label className="ht-alan-etiket" htmlFor="ht-mesaj-metin">{etiket}</label>
          <textarea id="ht-mesaj-metin" className="ht-taslak" data-testid="ht-mesaj-metin" rows={9} value={metin} readOnly={guncelDegil} onChange={(e) => metinDegisti(e.target.value)} />
        </>
      )}
      <div className="ht-mesaj-eylem">
        <button
          type="button"
          className="ht-btn"
          aria-disabled={bos || !kopyalaAcik || mesgul}
          aria-describedby={!kopyalaAcik && kopyalaNedeni !== null ? 'ht-kopya-neden' : undefined}
          data-testid="ht-kopyala"
          onClick={() => { if (!bos && kopyalaAcik && !mesgul) kopyala(); }}
        ><Ikon ad="kopya" kucuk />{M.mesajKopyala}</button>
        <button
          type="button"
          className="ht-btn"
          aria-disabled={!pdfAcik || mesgul}
          aria-describedby={!pdfAcik && kopyalaNedeni !== null ? 'ht-kopya-neden' : undefined}
          data-testid="ht-pdf-indir"
          onClick={() => { if (pdfAcik && !mesgul) pdfIndir(); }}
        ><Ikon ad="indir" kucuk />{M.mesajPdfIndir}</button>
        <p className="ht-gonderme"><Ikon ad="kilit" kucuk /><span><b>{M.mesajSatisci.split('. ')[0]}.</b> {M.mesajSatisci.split('. ').slice(1).join('. ')}</span></p>
      </div>
      {!kopyalaAcik && kopyalaNedeni !== null ? <p className="ht-kapali" id="ht-kopya-neden"><b>{M.kapali}</b> {kopyalaNedeni}</p> : null}
    </section>
  );
}
